<template>
    <div>
        <el-tabs v-model="query.is_sj" @tab-click="handleSearch">
            <el-tab-pane label="上架" name="1"></el-tab-pane>
            <el-tab-pane label="下架" name="2"></el-tab-pane>
        </el-tabs>
        <ListPage ref="listPage" :query="query" :total="total" v-loading="loading" :data="tableData"
            @size-change="handleSizeChange" @current-change="handleCurrentChange" @search="handleSearch"
            @reset="resetQuery" @selection-change="handleSelectionChange">
            <template slot="filters">
                <el-form-item label="" prop="search_keyword">
                    <el-input v-model="query.search_keyword" placeholder="商品名称、用户名" clearable
                        @keyup.enter.native="handleSearch" />
                </el-form-item>
                <el-form-item label="评论时间" prop="date">
                    <el-date-picker v-model="query.date" type="daterange" align="left" unlink-panels range-separator="-"
                        value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
            </template>
            <template slot="btns" v-if="permission('cpgl_pllb_dc')">
                <el-button size="mini" type="primary" @click="handleExport"> 导出 </el-button>
            </template>
            <template slot="columns">
                <el-table-column type="selection" width="50" align="center"></el-table-column>
                <el-table-column label="商品名称" align="center" prop="goods_name" />
                <el-table-column label="评价内容" align="center" prop="content" />
                <el-table-column label="用户名" align="center" prop="user_nick_name" />
                <el-table-column label="状态" align="center" prop="is_sj">
                    <template slot-scope="{ row }">
                        {{ row.is_sj == 1 ? "上架" : "下架" }}
                    </template>
                </el-table-column>
                <el-table-column label="评论时间" align="center" prop="create_time" />
                <el-table-column v-if="
                    permission('cpgl_pllb_qxzd') ||
                    permission('cpgl_pllb_zd') ||
                    permission('cpgl_pllb_yc') ||
                    permission('cpgl_pllb_xs') ||
                    permission('cpgl_pllb_ck') ||
                    permission('cpgl_pllb_hf') ||
                    permission('cpgl_pllb_sc')
                " label="操作" align="center" width="220">
                    <template slot-scope="{ row }">
                        <el-button
                            v-if="row.is_sj == 1 && permission(row.is_top == 1 ? 'cpgl_pllb_qxzd' : 'cpgl_pllb_zd')"
                            size="mini" type="text" @click="handleTop(row)">{{ row.is_top == 1 ? "取消置顶" : "置顶" }}
                        </el-button>
                        <el-button v-if="permission(row.is_sj == 1 ? 'cpgl_pllb_yc' : 'cpgl_pllb_xs')" size="mini"
                            type="text" @click="handleStatus(row)">
                            {{ row.is_sj == 1 ? "下架" : "上架" }}
                        </el-button>
                        <el-button v-if="permission('cpgl_pllb_ck')" size="mini" type="text" @click="handleView(row)">
                            查看 </el-button>
                        <el-button v-if="row.is_sj == 1 && permission('cpgl_pllb_hf')" size="mini" type="text"
                            @click="handleReply(row)">
                            回复
                        </el-button>
                        <el-button v-if="permission('cpgl_pllb_sc')" size="mini" type="text" @click="handleDel(row)"> 删除
                        </el-button>
                    </template>
                </el-table-column>
            </template>
        </ListPage>
        <Reply ref="reply" @update="search"></Reply>
        <ViewVue ref="view"></ViewVue>
    </div>
</template>

<script>
import { list, del, sj, top } from "@/api/product/comment";
import { startDate, endDate } from "@/pages/config";
import listMixin from "@/mixins/list";
import { downloadFileByUrl } from "@/jslibs/utils";
import Reply from "./reply.vue";
import ViewVue from "./view.vue";

export default {
    components: { Reply, ViewVue },
    data() {
        return {
            list,
            del,
            // 查询参数
            query: {
                search_keyword: "",
                is_sj: "1",
                date: [],
            },
            module: "评论",
            pick: true,
        };
    },
    mixins: [listMixin],
    mounted() {
        this.search();
    },
    methods: {
        search() {
            const params = {
                ...this.query,
                search_start_time: this.query.date && this.query.date[0] ? startDate(0, this.query.date[0]) : null,
                search_end_time: this.query.date && this.query.date[1] ? endDate(0, this.query.date[1]) : null,
            };
            delete params.date;
            this._search(params);
        },
        handleSelectionChange(val) {
            this.ids = val.map((x) => x.uuid);
            this.names = val;
            this.ids_d = this.tableData.filter((x) => this.ids.indexOf(x.uuid) === -1).map((x) => x.uuid);
            this.merge();
        },
        async handleExport() {
            const filename = "评论列表.xlsx";
            const { search_keyword, is_sj, date } = this.query;
            const [search_start_time, search_end_time] = date;
            const uuids = this.picks.map(x => x.uuid).join();
            downloadFileByUrl(
                process.env.VUE_APP_BASE_URL +
                `/v1/cms/GoodsComment?export=1&search_keyword=${search_keyword}&is_sj=${is_sj}&search_start_time=${search_start_time || ''}&search_end_time=${search_end_time || ''}&uuids=${uuids}`,
                filename
            );
        },
        handleReply(row) {
            this.$refs.reply.open(row);
        },
        handleTop(row) {
            top({ uuid: row.uuid, is_top: row.is_top == 1 ? 2 : 1 }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(row.is_top == 1 ? "取消置顶成功" : "置顶成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleStatus(row) {
            sj({ uuid: row.uuid, is_sj: row.is_sj == 1 ? 2 : 1 }).then(({ code, error }) => {
                if (code == 200) {
                    this.search();
                    this.$message.success(row.is_sj == 1 ? "下架成功" : "上架成功");
                } else {
                    this.$message.error(error.message);
                }
            });
        },
        handleView(row) {
            this.$refs.view.open(row);
        },
    },
};
</script>
